export default {"src":"/_next/static/media/tag-heart.1c96a6bc.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};